// A one-shot promise that resolves once the initial session restore has settled
// (see main.js). The router guard awaits this instead of the overloaded `loading`
// flag, so it can make a correct authed/anonymous decision without a visible bounce.
let resolveFn;
export const authReadyPromise = new Promise((r) => { resolveFn = r; });
export function resolveAuthReady() {
  if (resolveFn) resolveFn();
}
